<template>
  <div>
    <!--  固定位搜索栏  -->
    <van-search class="fixed width-99 z-99" clearable shape="round" v-model="queryParams.title" show-action
                @search="onSearch">
      <template #action>
        <div class="w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center" @click="onSearch">搜索</div>
      </template>
    </van-search>
    <!--  站位盒子  -->
    <div class="h-110"></div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished"
                finished-text="没有更多了" @load="getList"
                class="p-l-20 p-r-20 p-b-20">
        <div @click="change(item)" v-for="(item,index) in list" :key="index" class="bg-FF p-20 m-t-20">
          <div class="flex col-center row-between">
            <img class="w-52 h-52" :src="`${image_base_url}/zhengxuanlist_icon.png`"></img>
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ item.title }}
            </div>
            <div class="font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7">
              {{ item.businessStatusName }}
            </div>
          </div>

          <van-row type="flex" align="center" class="m-t-30">
            <van-col span="10">
              <div class="cor-88 font-30">部门</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ item.businessData.startDeptName }}
              </div>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">离职日期</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ item.summary ? item.summary.split(':')[1] : '暂无数据' }}
              </div>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">申请时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ item.startTime ? moment(item.startTime).format('YYYY-MM-DD hh:mm') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">离职原因</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ item.sy }}
              </div>
            </van-col>
          </van-row>



        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {workList} from '@/api/flow'
import mixin from '@/mixin/flow'
import moment from "moment";

export default {
  name: 'reimbursement-list',
  mixins: [mixin],
  data() {
    return {
      moment,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      queryParams: {
        groupId: "10",
        pageNum: 1,
        pageSize: 10,
        templateId: "",
        title: ""
      }
    }
  },
  created() {
    this.queryParams = Object.assign(this.queryParams, this.$route.query)
    this.getList()
  },

  methods: {
    change(item) {
      this.$emit('change', item)
    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    },

    onSearch() {
      this.finished = false
      this.queryParams.pageNum = 1;
      this.list = []
      this.getList();
    },
    getList() {
      this.loading = true;
      workList(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        this.error = true
      })
    }
  }
}

</script>
<style scoped lang="less">

</style>